import { Link } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';

export interface EntitySubheaderProps {
  entity: Entity;
}

export const EntitySubheader: React.FC<EntitySubheaderProps> = ({ entity }) => {
  const kind = entity.kind.toLowerCase();
  const type = String(entity.spec?.type || 'Unknown');
  const lifecycle = String(entity.spec?.lifecycle || 'Unknown');
  const owner = entity.spec?.owner;

  return (
    <span>
      This {kind} is of type <b>{type}</b>, it is in the <b>{lifecycle}</b>{' '}
      lifecycle and is owned by{' '}
      {owner ? (
        <Link
          href={`/catalog/default/group/${String(owner)}`}
          color="inherit"
          underline="hover"
        >
          <b>{String(owner)}</b>
        </Link>
      ) : (
        <b>Unknown</b>
      )}
    </span>
  );
};
